module.exports = __webpack_public_path__ + "static/petitorio-bruno-horizontal-4b9ee757b726b85fbb6c699dfe1fb62f.jpeg";